import Banner1 from "../components/image/Banner1.jpg";
import Banner2 from "../components/image/Banner2.jpg";
import Banner3 from "../components/image/Banner3.jpg";
import Banner4 from "../components/image/Banner4.jpg";
import Kd1 from "../components/image/kd1.jpg";
import FounderCEO from "../components/image/CEO.jpg";
import DirectorAO2 from "../components/image/DIRECTOR2..jpeg";
import headCambridge from "../components/image/headCambridge.png";
import ProfAyoyemi from "../components/image/Professor Ayoyemi Lawal-Arowolo.png";


export const GENERAL_PAGES = [
  {
    path: "/founder-director",
    eyebrow: "Founder & Director",
    title: "Messages from our Founder and Director",
    description:
      "Our leadership story at S-TEE Schools is rooted in a clear conviction: good education can transform lives, open doors, and prepare young people for meaningful leadership and contribution.",
    heroImage: Banner3,
    heroImageAlt: "S-TEE founder and director page",
    heroActions: [
      { label: "Apply for Admissions", path: "/admissions/apply", variant: "primary" },
      { label: "About S-TEE", path: "/about", variant: "secondary" },
      { label: "Contact S-TEE", path: "/contact", variant: "ghost" },
    ],
    stats: [
      { value: "Since 1978", label: "school journey" },
      { value: "2", label: "leadership voices" },
      { value: "20+ Years", label: "director experience" },
    ],
    leadershipSection: {
      label: "Leadership Voices",
      title: "The convictions shaping the S-TEE experience",
      profiles: [
        {
          eyebrow: "Message from the Proprietress",
          name: "Madam T. S. Lawal",
          role: "Founder and Proprietress, S-TEE Schools",
          initials: "TSL",
          image: FounderCEO,
          imageAlt: "Madam T. S. Lawal, Founder and Proprietress of S-TEE Schools",
          messageTitle: "Education should open doors and build lives of impact",
          messageParagraphs: [
            "It is my utmost pleasure welcoming you to our world here in S-TEE Schools. I have come to know that one of the biggest influences that can turn one’s life around is the power of a good education. From my humble beginnings, I can look back and identify the huge contributions that education has made in my life.",
            "Education unlocks the door to great opportunities, education rescues one from the chains of oppressive cultural and religious practices; education empowers one to create wealth, create jobs and despite the prevalence of poverty, education makes one to see the gold mines even in a desert.",
            "Our culture in S-TEE is to create the right foundation for every learner. Learning is fun when the learner is recognised for who he/she is, participates in the process, is guided, loved and appreciated, is made to work and play in a friendly, colourful and inspiring environment.",
            "Our values celebrate the indispensable requirements for every responsible human being. The need to fear God and live a godly life is paramount; Respect and due regard for others is a non-negotiable demand; Discipline, responsibility and excellence must be reflected in our everyday life.",
            "Our culture, values and beliefs have all worked together to get us to where we are now. We trust God and have always done our best to produce great people every year. These testimonies abound in various sectors and professions in Nigeria and in the global community.",
            "As we remain tireless and uncompromising in raising standards and pushing boundaries, we believe all our products will show forth excellence wherever they are.",
          ],
        },
        {
          eyebrow: "From the Director's Desk",
          name: "Mrs. Ayoyinka Owairu",
          role: "Director, S-TEE Schools",
          reverse: true,
          initials: "AO",
          image: DirectorAO2,
          imageAlt: "Mrs. Ayoyinka Owairu, Director of S-TEE Schools",
          messageTitle: "Academic excellence and leadership formation must grow together",
          messageParagraphs: [
            "Every child is born to be a star, a change agent, a contributor and a facilitator of new ideas. Education creates the platform for the realization of this blue print and excellence is an effectual ingredient in creating that product. Societies, civilization and economic growth are built by quality resource personnel.",
            "In S-TEE, we painstakingly work at the proper mix of academic and leadership training into our curriculum. We deploy a rigorous but result-oriented academic system that trains our learners to imbibe the confidence and competence needed to soar ahead in a competitive environment. Our school operation is tailored to help each learner understand who they are and how to be the best in whatever they do.",
            "The 21st century is an age that demands global perspective in training and resource development for teaching and for learning.",
            "S-TEE gives learning to students as well as tools to create their own world and fulfil their destinies. Trust us to provide excellence educational services to your children and watch them take over the world.",
          ],
          profileTitle: "Profile of Mrs. Ayoyinka Owairu",
          profileParagraphs: [
            "Mrs. Ayoyinka Owairu, Director of S-TEE Schools, is a seasoned administrator and educationalist with over 20 years experience in various capacities as a key decision maker, policy maker and stakeholder with board level credibility and experience managing large scale projects. A goal driver with doggedness for creating working cultures and raising and building effective working teams.",
            "Mrs. Ayoyinka is an inspirational leader, experienced consultant and teacher, with top level responsibilities which includes organizational value creation, systems and structural definitions, design and implementation of programmes to ensure delivery of organizational goals and targets and equipping and mentoring top level staff. She is deft in creating organizational structure that reflect organizational values and enables management systems, structures and processes to work effectively in line with cultures and visions and ensuring that all statutory requirements are met.",
            "As an educationist, she has experience in the development and implementation of broad and relevant curriculum which embraces the schools specialisms, innovative approaches to teaching and learning, and leading best practices in teaching methodologies. She is also vast in mentoring and evaluating local and international curriculum for both quality and effective delivery.",
            "Mrs. Ayoyinka Owairu’s core competencies include training, research and development of programmes and curriculum, culture and team building, mentoring, equipping and empowering through resources management, evaluating and reviewing administrative and managerial practice and providing improvement strategies leading to raised standards.",
          ],
        },
      ],
    },
    sidebarSection: {
      label: "School Information",
      title: "Leadership support and useful next steps",
      cards: [
        {
          title: "Department Menu",
          items: [
            { label: "Apply for Admissions", path: "/admissions/apply" },
            { label: "Download Prospectus", path: "/admissions/prospectus" },
            { label: "Latest News", path: "/admissions/latest-news" },
            { label: "Contact S-TEE", path: "/contact" },
          ],
        },
        {
          title: "Corporate Office Contact Info",
          items: [
            "H Close, 5th Avenue",
            "Festac Town, Lagos, Nigeria",
            "+234-704-567-1842",
            "info@steeschools.com",
            "Mon - Fri, 9:00 A.M. - 5:00 P.M.",
          ],
        },
        {
          title: "Leadership Themes",
          items: [
            "Education as a life-transforming force",
            "Godliness, respect, discipline, and responsibility",
            "Academic excellence supported by leadership training",
          ],
          note:
            "These ideas run through the founder's message, the director's desk, and the wider S-TEE story.",
        },
        {
          title: "Move Forward",
          items: [
            "Families can move from the leadership story into admissions, school culture, or direct contact without losing momentum.",
          ],
          ctaLabel: "Open Admissions",
          ctaPath: "/admissions",
        },
      ],
    },
    footerCta: {
      title: "Ready to move from leadership story into the school journey?",
      text:
        "Continue into admissions, explore the school story, or contact the school directly from here.",
      ctaLabel: "Explore Admissions",
      ctaPath: "/admissions",
    },
  },
  {
    path: "/gallery",
    eyebrow: "Gallery",
    title: "S-TEE Events and Gallery",
    description:
      "The gallery gives families a stronger visual sense of school life at S-TEE, from classroom moments and campus atmosphere to celebrations, events, and everyday student engagement.",
    heroImage: Kd1,
    heroImageAlt: "School gallery visual",
    stats: [
      { value: "5", label: "featured image blocks" },
      { value: "School Life", label: "made visible" },
      { value: "Events", label: "more memorable online" },
    ],
    focus: {
      label: "Visual Storytelling",
      title: "Strong visuals help families understand the school faster",
      text:
        "A well-shaped gallery can support admissions, strengthen trust, and show what the school environment feels like in ways that text alone cannot.",
      list: [
        "Show students learning, participating, and celebrating together.",
        "Use image collections to reinforce the school's atmosphere and standards.",
        "Help parents imagine what everyday life at S-TEE looks like for their children.",
      ],
    },
    callout: {
      label: "Best Use",
      title: "A strong gallery supports trust and enquiry",
      text:
        "For many parents, strong visuals become the bridge between first interest and a more serious admissions conversation.",
      ctaLabel: "Learn About S-TEE",
      ctaPath: "/about",
    },
    cardsSection: {
      label: "Album Ideas",
      title: "The collections that bring the S-TEE story to life",
      items: [
        {
          title: "Campus Life",
          text:
            "Images that show the school environment, student routines, and the everyday feel of the campus.",
        },
        {
          title: "Events and Celebrations",
          text:
            "Moments from assemblies, special programmes, ceremonies, and other community milestones.",
        },
        {
          title: "Learning in Action",
          text:
            "Photos that show participation, teamwork, concentration, and the energy of students at work.",
        },
      ],
    },
    gallerySection: {
      label: "Featured Moments",
      title: "A stronger visual rhythm for the S-TEE story",
      images: [
        { src: Banner1, alt: "S-TEE featured moment one", tag: "Campus Welcome" },
        { src: Banner2, alt: "S-TEE featured moment two", tag: "Classroom Life" },
        { src: Banner3, alt: "S-TEE featured moment three", tag: "School Experience" },
        { src: Banner4, alt: "S-TEE featured moment four", tag: "Community" },
        { src: Kd1, alt: "S-TEE featured moment five", tag: "Student Highlights" },
      ],
    },
    footerCta: {
      title: "Ready to turn visual interest into enquiry?",
      text:
        "Lead interested families from the gallery into admissions or direct school contact.",
      ctaLabel: "Contact S-TEE",
      ctaPath: "/contact",
    },
  },
  {
    path: "/career",
    eyebrow: "Career",
    title: "Career Opportunities at S-TEE Schools",
    description:
      "Career opportunities at S-TEE give educators and school professionals a clearer view of the values-led, disciplined, and student-focused environment the school is building.",
    heroImage: Banner2,
    heroImageAlt: "Professional school recruitment theme",
    stats: [
      { value: "Teaching", label: "and support roles" },
      { value: "Values-Led", label: "team culture" },
      { value: "Purpose", label: "beyond the job title" },
    ],
    focus: {
      label: "Working at S-TEE",
      title: "Careers at S-TEE combine opportunity with mission",
      text:
        "Candidates want more than vacancy titles. They want to understand the environment, expectations, and purpose of the team they may be joining.",
      list: [
        "Show what kind of people and values the school wants to attract.",
        "List open roles clearly when vacancies exist.",
        "Give interested candidates a simple and credible way to make contact.",
      ],
    },
    callout: {
      label: "Recruitment Support",
      title: "S-TEE can still welcome strong candidates between hiring cycles",
      text:
        "S-TEE can invite future educators, administrators, and support staff to express interest while reinforcing the culture of the school.",
      ctaLabel: "Contact the School",
      ctaPath: "/contact",
    },
    cardsSection: {
      label: "What to Include",
      title: "The sections that make S-TEE careers clearer",
      items: [
        {
          title: "Open Positions",
          text:
            "Display current vacancies with role names, short descriptions, and clear next-step guidance.",
        },
        {
          title: "Why Join S-TEE",
          text:
            "Explain what makes the school's environment meaningful for educators and other staff members.",
        },
        {
          title: "Application Process",
          text:
            "Keep application expectations simple so strong candidates know how to respond confidently.",
        },
      ],
    },
    faqSection: {
      label: "Careers FAQ",
      title: "Helpful recruitment questions to answer here",
      items: [
        {
          question: "What roles does S-TEE recruit for?",
          answer:
            "S-TEE recruits across teaching, administration, operations, and support roles.",
        },
        {
          question: "What if there are no vacancies right now?",
          answer:
            "S-TEE can still welcome expressions of interest from qualified candidates who align with the school's values.",
        },
        {
          question: "How can candidates apply?",
          answer:
            "Candidates can be guided to apply by email, contact form, or another approved school process.",
        },
        {
          question: "What should candidates know about S-TEE culture?",
          answer:
            "S-TEE values discipline, professionalism, learner growth, and purposeful collaboration.",
        },
      ],
    },
    footerCta: {
      title: "Need the broader school mission behind the team culture?",
      text:
        "The About page helps candidates understand the bigger S-TEE story before they reach out.",
      ctaLabel: "View About Us",
      ctaPath: "/about",
    },
  },
  {
    path: "/about",
    eyebrow: "About Us",
    title: "Know S-TEE Better",
    description:
      "Since September 1978, S-TEE Schools has been committed to giving learners strong moral, academic, spiritual, and life training so they can grow into responsible leaders and global contributors.",
    heroImage: Banner1,
    heroImageAlt: "About S-TEE overview",
    heroActions: [
      { label: "Meet the Leadership", path: "/founder-director", variant: "primary" },
      { label: "Explore Admissions", path: "/admissions", variant: "secondary" },
      { label: "Contact S-TEE", path: "/contact", variant: "ghost" },
    ],
    stats: [
      { value: "Since 1978", label: "school history" },
      { value: "Nursery to A Level", label: "learning span" },
      { value: "4", label: "core values" },
    ],
    focus: {
      label: "S-TEE History",
      title: "A school built to give children the right foundation for life",
      text:
        "S-TEE was established on the belief that education is central to a better life and that every child deserves the foundation skills needed to function effectively in the world around them.",
      list: [
        "S-TEE has been operating since September 1978.",
        "The school emphasizes moral, academic, spiritual, and life training together.",
        "Its long-term aim is to raise great minds, expert thinkers, and solution-driven future leaders.",
      ],
    },
    callout: {
      label: "Management Team",
      title: "Leadership remains a visible part of the school story",
      text:
        "S-TEE's management team connects school direction, leadership, and organizational support across nursery, primary, high school, legal, and HR functions.",
      ctaLabel: "View Founder and Director",
      ctaPath: "/founder-director",
    },
    cardsSection: {
      label: "Core Story Areas",
      title: "The foundations of the S-TEE identity",
      items: [
        {
          title: "Our History",
          text:
            "S-TEE was established to help learners build the foundation skills, moral direction, and academic preparation needed for life and future relevance.",
        },
        {
          title: "Our Vision",
          text:
            "The school's vision is to build hope, academic excellence, and leadership aspiration in young people through a programmed education that inspires them to realize their full potential.",
        },
        {
          title: "Our Mission",
          text:
            "S-TEE's mission is to raise a godly generation of students with high moral and academic standards who will stand for excellence and integrity as global leaders.",
        },
      ],
    },
    statementSection: {
      label: "Core Values",
      title: "The values the school keeps visible",
      text:
        "Four values shape the school's tone, standards, and relationships across the community.",
      items: [
        "Excellence",
        "Discipline",
        "Caring",
        "Tolerance",
      ],
      note:
        "These values support the larger picture presented across the founder, culture, and admissions pages.",
    },
    directorySection: {
      label: "Management Team",
      title: "The leadership team behind S-TEE",
      items: [
        {
          title: "Mrs. Ayoyinka Owairu",
          image: DirectorAO2,
          imageAlt: "Mrs. Ayoyinka Owairu, Director of S-TEE Schools",
          lines: [
            "Director, Nursery, Primary, and High School",
            "Visible leadership across academic and school operations.",
          ],
          ctaLabel: "Read Director Profile",
          ctaPath: "/founder-director",
        },
        {
          title: "Madam T. S. Lawal",
          image: FounderCEO,
          imageAlt: "Madam T. S. Lawal, Founder and Proprietress of S-TEE Schools",
          lines: [
            "Founder and Proprietress",
            "The founding voice behind the school's long-term educational direction.",
          ],
          ctaLabel: "Read Founder Message",
          ctaPath: "/founder-director",
        },
        {
          title: "Professor Ayoyemi Lawal-Arowolo",
          image: ProfAyoyemi,
          imageAlt: "Professor Ayoyemi Lawal-Arowolo, Director, Legal and HR",
          lines: [
            "Director, Legal and HR",
            "Supports the legal and human-resource direction of the school.",
          ],
        },
        {
          title: "Mr Ayodamola Philip King",
          image: headCambridge,
          imageAlt: "Mr Ayodamola Philip King",
          lines: [
            "Director, S-TEE Cambridge College, Okota, Lagos",
            "He is the CEO, Barnfield Wells Consulting (UK, Nigeria)",
            "Board Member J-First Group (UK)",
          ],
        },
      ],
    },
    stepsSection: {
      label: "School Highlights",
      title: "The wider story of S-TEE",
      items: [
        {
          title: "Special Campus Tour",
          text:
            "The site frames S-TEE as a place committed to human capital development and the wider restoration of society through education.",
        },
        {
          title: "Graduation",
          text:
            "The school serves Nursery, Primary, Junior and Senior Secondary levels, with broader academic ambition extending to international pathways.",
        },
        {
          title: "Powerful Alumni",
          text:
            "S-TEE is a multicultural school community where staff, students, parents, and the wider school family work together toward a healthy and responsible learning environment.",
        },
      ],
    },
    footerCta: {
      title: "Want to move from the school story into the school journey?",
      text:
        "Families who understand the S-TEE vision can continue straight into admissions from here.",
      ctaLabel: "Explore Admissions",
      ctaPath: "/admissions",
    },
  },
  {
    path: "/contact",
    eyebrow: "Contact",
    title: "Contact S-TEE Schools",
    description:
      "Families, students, and visitors can reach S-TEE through clear phone, email, and campus channels for admissions guidance, school enquiries and visit  5th Avenue, H-close, Fetac Town Lagos.",
    heroImage: Banner4,
    heroImageAlt: "Contact and support theme",
    heroActions: [
      { label: "Call S-TEE", href: "tel:+2347075152920", variant: "primary" },
      { label: "Email Admissions", href: "mailto:admission@steeschools.com", variant: "secondary" },
      { label: "Apply to S-TEE", path: "/admissions/apply", variant: "ghost" },
    ],
    stats: [
      { value: "+234-707-515-2920", label: "main calls line" },
      { value: "+234-704-567-1842", label: "WhatsApp only" },
      { value: "Festac, Lagos", label: "campus location" },
    ],
    focus: {
      label: "Contact Support",
      title: "Reach S-TEE quickly and clearly",
      text:
        "Families usually need three things first: the correct phone line, the right email address, and a clear sense of where the campus is located.",
      list: [
        "Use the calls line for direct school enquiries during official hours.",
        "Use the WhatsApp line when parents need a lighter admissions follow-up channel.",
        "Keep the campus address visible for visits and location guidance.",
      ],
    },
    callout: {
      label: "Visit Our Campus Today",
      title: "Phone, email, and location are always within easy reach",
      text:
        "Contact Us: call the school, email the team, or visit the campus in Festac Town for direct enquiries and support.",
      ctaLabel: "Open Admissions",
      ctaPath: "/admissions",
    },
    cardsSection: {
      label: "Best Contact Paths",
      title: "The information families usually need first",
      items: [
        {
          title: "Phone",
          text:
            "Reach us on +234-707-515-2920 for calls or use +234-704-567-1842 for WhatsApp-only follow-up.",
        },
        {
          title: "Email",
          text:
            "Use info@steeschools.com for general enquiries and admission@steeschools.com for admissions-specific support.",
        },
        {
          title: "Location",
          text:
            "Our main campus address remains 5th Avenue, H Close, Festac Town, Lagos, Nigeria.",
        },
      ],
    },
    directorySection: {
      label: "Contact Directory",
      title: "Official contact details in one place",
      items: [
        {
          title: "Phone Lines",
          lines: [
            "Calls: +234-707-515-2920",
            "WhatsApp only: +234-704-567-1842",
            "Reach us during official communication hours.",
          ],
          ctaLabel: "Call Now",
          ctaHref: "tel:+2347075152920",
        },
        {
          title: "Email Support",
          lines: [
            "General enquiries: info@steeschools.com",
            "Admissions support: admission@steeschools.com",
            "Use email when you need a follow-up response or extra guidance.",
          ],
          ctaLabel: "Send Email",
          ctaHref: "mailto:info@steeschools.com",
        },
        {
          title: "Campus Location",
          lines: [
            "5th Avenue, H Close",
            "Festac Town, Lagos, Nigeria",
            "Visit the campus for direct enquiries and school guidance.",
          ],
        },
      ],
    },
    faqSection: {
      label: "Contact FAQ",
      title: "Common questions families ask first",
      items: [
        {
          question: "Which number should parents call?",
          answer:
            "Our main call number is +234-707-515-2920 , while +234-704-567-1842 is our WhatsApp-only number.",
        },
        {
          question: "Which email should families use for admission support?",
          answer:
            "Families can use admission@steeschools.com for admissions-specific support and info@steeschools.com for general enquiries.",
        },
        {
          question: "Where is the school located?",
          answer:
            "S-TEE is located at 5th Avenue, H Close, Festac Town, Lagos, Nigeria.",
        },
        {
          question: "Can families move from contact into admissions?",
          answer:
            "Yes. Families can get the help they need and continue straight into admissions when they are ready.",
        },
      ],
    },
    stepsSection: {
      label: "Recommended Contact Flow",
      title: "A cleaner route from question to response",
      items: [
        {
          title: "Choose the reason for contact",
          text:
            "Visitors should be able to tell quickly whether they need admissions help, general support, or campus directions.",
        },
        {
          title: "Use the best channel",
          text:
            "Phone, WhatsApp, and email are easy to scan from a single place.",
        },
        {
          title: "Continue into the next step",
          text:
            "After getting help, families can move directly into admissions or other relevant school pages without losing direction.",
        },
      ],
    },
    footerCta: {
      title: "Prefer a more structured next step after contact?",
      text:
        "Admissions remain close for families who are ready to continue after speaking with the school.",
      ctaLabel: "Visit Admissions",
      ctaPath: "/admissions",
    },
  },
];
